import {
	ElementProps,
	TextInputProps,
	InputStylesNames,
	InputWrapperStylesNames,
	createPolymorphicComponent,
	TextInput,
	ActionIcon,
} from '@mantine/core';
import { Search, X } from 'lucide-react';
import { ChangeEvent, forwardRef } from 'react';

export type SearchInputProps = {
	clearable?: boolean;
} & TextInputProps &
	Omit<ElementProps<'input', keyof TextInputProps>, 'classNames'> & {
		classNames?: Partial<Record<InputStylesNames | InputWrapperStylesNames, string>>;
	};

export const SearchInput = createPolymorphicComponent<'input', SearchInputProps>(
	forwardRef<HTMLInputElement, SearchInputProps>(
		({ clearable = true, value, onChange, ...props }, ref) => (
			<TextInput
				data-test-id={props.id || 'search-input'}
				leftSection={<Search />}
				rightSection={
					clearable && value ? (
						<ActionIcon
							data-test-id='clear-search-button'
							variant='ghost-secondary'
							size='sm'
							onClick={() => onChange?.({ target: { value: '' } } as ChangeEvent<HTMLInputElement>)}
						>
							<X />
						</ActionIcon>
					) : null
				}
				leftSectionPointerEvents='none'
				value={value}
				onChange={onChange}
				{...props}
				ref={ref}
			/>
		),
	),
);
